<script lang="ts">
    import { machine_addBinState, machine_execute, machine_setAlphabet, machine_startExecution } from './actions/machine';
    import { fullscreen_toggle, setEditMode, startAddTransition } from './actions/ui';
    import { getConfiguration, getState } from './context';
    import { exhaustiveCheck } from './exhaustiveCheck';
    import { machine_alphabet } from './state/machine';
    import { machine_missingTransitions } from './state/state';
    import IconDelete from './icons/Delete.svelte';
    import IconSimulation from './icons/Simulation.svelte';
    import IconEdit from './icons/Edit.svelte';
    import IconSave from './icons/Save.svelte';
    import IconLoad from './icons/Load.svelte';
    import IconExportSVG from './icons/ExportSVG.svelte';
    import IconAddNodeRect from './icons/AddNodeRect.svelte';
    import IconAddTransition from './icons/AddTransition.svelte';
    import IconNewProject from './icons/NewProject.svelte';
    import IconFullscreen from './icons/Fullscreen.svelte';
    import { EditMode } from './state/uiState';
    import { file_load } from './actions/file';
    import { mealyMachine_errors } from './mealy/mealyErrorsInMachine';
    import { popUpMessage_hide, popUpMessage_show } from './actions/popUpMessage';
    import * as F from 'fp-ts/Function';
    import { dialog_openNewAutomaton } from './actions/dialog';
    
    const state = getState();
    $: uiState = $state.machineState.uiState;
    $: machine = $state.machineState.machine;

    export let onScreenshot: () => void;

    const conf = getConfiguration();
    // console.log(conf)

    function handleNewStateClicked() {
        if (uiState.editMode === EditMode.ADD_STATE) {
            state.set(setEditMode($state, EditMode.NEUTRAL));
        } else {
            state.set(setEditMode($state, EditMode.ADD_STATE));
        }
    }

    function handleNewTransitionClicked() {
        if (uiState.editMode === EditMode.ADD_TRANSITION) {
            state.set(setEditMode($state, EditMode.NEUTRAL));
        } else {
            state.set(startAddTransition($state));
        }
    }

    function handleDeleteClick() {
    if (uiState.editMode === EditMode.DELETE) {
            state.set(setEditMode($state, EditMode.NEUTRAL));
        } else {
            state.set(setEditMode($state, EditMode.DELETE));
        }
    }

    let eingabe = '';
    function handleExecuteClick() {
        switch($state.machineState.type) {
            // evtl. hier keine Fallunterscheidung; stattdessen Fallunterscheidung in machine_startExecution($state)
            case 'MachineStateMealy':
                // machineStateMealy_errors($state.machineState);

                if (uiState.editMode === EditMode.EXECUTION) {
                    state.set(setEditMode($state, EditMode.NEUTRAL));
                } else {
                    const errors = mealyMachine_errors($state.machineState.machine);
                    if (errors.length > 0) {
                        state.set(popUpMessage_show($state, 'Fehler im Automaten. Die Simulation kann nicht gestartet werden.'));
                    } else {
                        const newState = F.pipe(
                            $state,
                            popUpMessage_hide,
                            machine_startExecution
                        )
                        state.set(newState);
                    }
                }
                break;
            case 'MachineStateDEA':
                const missingTransitions = machine_missingTransitions(machine);

                if (missingTransitions.length > 0) {
                    state.set(machine_addBinState($state, missingTransitions));
                }

                state.set(machine_execute($state, eingabe));
                break;
            default:
                exhaustiveCheck($state.machineState);
        }
    }

    function handleResetClick() {
        switch($state.machineState.type) {
            // evtl. hier keine Fallunterscheidung; stattdessen Fallunterscheidung in machine_startExecution($state)
            case 'MachineStateMealy':
                // machineStateMealy_errors($state.machineState);

                if (uiState.editMode === EditMode.EXECUTION) {
                    const errors = mealyMachine_errors($state.machineState.machine);
                    if (errors.length > 0) {
                        state.set(popUpMessage_show($state, 'Fehler im Automaten. Die Simulation kann nicht gestartet werden.'));
                    } else {
                        const newState = F.pipe(
                            $state,
                            popUpMessage_hide,
                            machine_startExecution
                        )
                        state.set(newState);
                    }
                }
                break;
            case 'MachineStateDEA':
                break;
            default:
                exhaustiveCheck($state.machineState);
        }
    }

    function handleAlphabetInput(event) {
        const target = event.target as HTMLInputElement;
        const value = target.value.split('');
        state.set(machine_setAlphabet($state, value));
    }

    function handleSaveClick() {
        if ($state.machineState.type === 'MachineStateMealy') {
            const saveObject = {
                type: 'SaveObjectMealy',
                machine: $state.machineState.machine,
                mealyModelType: $state.machineState.mealyModelType,
            };

            var link = document.createElement('a');
		    link.download = 'automat.json';
            link.href = 'data:text/plain;charset=utf-8,' + JSON.stringify(saveObject);
            link.click();
        };
    }

    function handleLoadClick() {
		let input = document.createElement('input');
		input.type = 'file';
		input.onchange = (_ => {
			let files = Array.from(input.files);
			if (files.length > 0) {
				let file = files[0];
				let reader = new FileReader();
				reader.onload = (e => {
					let contents = e.target.result;
                    let saveObject = JSON.parse(contents.toString());
					state.set(file_load($state, saveObject));
				});
				reader.readAsText(file);
			}
		});
		input.click();
	}

    function handleEditClick() {
        state.set(setEditMode($state, EditMode.NEUTRAL));
    }

    function handleNewClick() {
        // state.set(machine_newProject($state));
        state.set(dialog_openNewAutomaton($state));
    }

    function handleFullscreenClick() {
        const newState = fullscreen_toggle($state);
        state.set(newState);

        if (newState.fullscreen) {
            document.body.style["overflow-y"] = 'hidden'
        } else {
            document.body.style["overflow-y"] = ''
        }
    }

    function handleExportSVGClick() {
        onScreenshot();
    }
</script>

<!-- border: 2px solid lightgrey; padding: 5px; margin: 5px; -->
<div style="background-color: white; padding: 10px; border-radius: 10px; margin-bottom: 10px;">
    {#if conf.menuItems.showNewAutomaton}
        <button 
            on:click={handleNewClick}
            class="automaten-simulator-iconButton"
        >
            <IconNewProject />
        </button>
        <span style="margin-right: 20px"></span>
    {/if}

    <button 
        on:click={handleExecuteClick}
        class="automaten-simulator-iconButton"
        class:buttonHighlight="{uiState.editMode === EditMode.EXECUTION}"
    >
        <IconSimulation />
    </button>

    <span style="margin-right: 20px"></span>

    <button
        on:click={handleEditClick}
        class="automaten-simulator-iconButton"
        class:buttonHighlight="{uiState.editMode === EditMode.NEUTRAL}"
    >
        <IconEdit />
    </button>

    <button 
        class="automaten-simulator-iconButton"
        class:buttonHighlight="{uiState.editMode === EditMode.DELETE}"
        on:click={handleDeleteClick}
    >
        <IconDelete />
    </button>

    <button
        on:click={handleNewStateClicked}
        class:buttonHighlight="{uiState.editMode === EditMode.ADD_STATE}"
        class="automaten-simulator-iconButton"
    >
        <IconAddNodeRect />
    </button>
    
    <button
        on:click={handleNewTransitionClicked}
        class:buttonHighlight="{uiState.editMode === EditMode.ADD_TRANSITION}"
        class="automaten-simulator-iconButton"
    >
        <IconAddTransition />
    </button>

    {#if machine.type === 'DEA'}
        Alphabet: <input value={machine_alphabet(machine)} on:input={handleAlphabetInput} />
        <input bind:value={eingabe} placeholder="Gib eine Zeichenkette ein" />
    {/if}

    <span style="margin-right: 20px"></span>

    {#if conf.menuItems.showSaveAutomaton}
        <button 
            on:click={handleSaveClick}
            class="automaten-simulator-iconButton"
        >
            <IconSave />
        </button>
    {/if}

    {#if conf.menuItems.showLoadAutomaton}
        <button
            on:click={handleLoadClick}
            class="automaten-simulator-iconButton"
        >
            <IconLoad />
        </button>
        <span style="margin-right: 20px"></span>
    {/if}


    {#if conf.menuItems.showScreenshot}
        <button
            on:click={handleExportSVGClick}
            class="automaten-simulator-iconButton"
        >
            <IconExportSVG />
        </button>
        <span style="margin-right: 20px"></span>
    {/if}


    <button
        on:click={handleFullscreenClick}
        class="automaten-simulator-iconButton"
    >
        <IconFullscreen />
    </button>
    
    <!-- <button
        on:click={handleResetClick}
        class="automaten-simulator-iconButton"
    >
        <IconResetSimulation />
    </button> -->
</div>

<style>
    .buttonHighlight {
        background-color: #d7ffc5;
    }
    .buttonHighlight:hover {
        background-color: rgb(99, 252, 104);
    }
</style>